import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { DesktopPageWrapper } from './PageContainer.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

class PageContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sideNavExpanded: false,
      /* eslint-disable-next-line react/no-unused-state */
      mounted: false
    };
  }

  componentDidMount() {
    /* eslint-disable-next-line react/no-unused-state */
    this.setState({ mounted: true });
  }

  static getDerivedStateFromProps(props, state) {
    const { sideExpanded } = props;
    const { mounted } = state;
    if (!mounted) {
      return { sideNavExpanded: false };
    }
    return { sideNavExpanded: sideExpanded };
  }

  render() {
    const { children } = this.props;
    const { sideNavExpanded } = this.state;
    return (
      <CSSTransition in={sideNavExpanded} timeout={400} classNames="stretch">
        <DesktopPageWrapper>{children}</DesktopPageWrapper>
      </CSSTransition>
    );
  }
}

PageContainer.propTypes = {
  /** Page component to wrap with this layout. */
  children: ReactChildrenPropType,

  /* eslint-disable-next-line react/no-unused-prop-types */
  sideExpanded: PropTypes.bool
};

PageContainer.defaultProps = {
  children: null,
  sideExpanded: false
};

export default PageContainer;
